<template>
  <div v-if="clerk">
    <div class="header">
      <div class=" " style="display: flex;align-items: center;  height: 80px;">
        <div class="photo">
          <img :src="clerk.avatarUrl" style="width: 80px;height: 80px">
        </div>
        <div class="info">
          <div>{{clerk.name}}</div>
<!--          <div>本周排名：{{myRanking.ranking}}</div>-->
<!--          <div>等级：{{$store.state.ClerkGradeMap[clerk.grade]}}</div>-->
          <div>性别：{{clerk.sex == 1? '男' : '女'}}</div>
        </div>

        <div style="display: flex;flex-direction: column; align-items: flex-end">
          <div  style="display: flex; margin: 2px 0 8px">
            <span v-if="clerk.status == 1" style="color:var(--primary-color);">在线</span>
            <span v-else-if="clerk.status == 2" class="text-gray">离线</span>
            <van-switch :active-value="1" :inactive-value="2" :loading="updateClerkStatusLoading" :value="clerk.status"
                        active-color="var(--primary-color)" class="margin-left-sm" inactive-color="var(--grey)" size="18"
                        @input="(input)=>updateStatus(input,'clerk')"/>
          </div>

          <div v-if="$hasFeature('auto_online')" style="display: flex;margin: 5px 0 5px">
            <!--            <span v-if="clerkIsAutoOnline" class="text-green" >自动在线</span>-->
            <span v-if="clerkIsAutoOnline" style="color:var(--primary-color);">自动在线</span>
            <span v-else-if="!clerkIsAutoOnline" class="text-gray">手动在线</span>
            <van-switch v-model="clerkIsAutoOnline" active-color="var(--primary-color)" class="margin-left-sm "
                        inactive-color="var(--grey)"
                        size="18" @input="(input)=>updateClerkIsAutoOnline(input)"/>
          </div>
          <div v-if=" $ClerkPermission.modifiableClerkAttr.includes('randomOrderSwitch')" class="flex justify-end align-center margin-top-sm">
          <span :style="{color:clerk.randomOrderSwitch?'var(--primary-color)':'gray'}" class="flex align-center">
            <question-mark class="margin-right-xs" msg="在线且随机单开启时，才会接收到随机单通知"/>
            随机单
          </span>
            <van-switch :value="clerk.randomOrderSwitch" active-color="var(--primary-color)" class="margin-left-sm"
                        inactive-color="var(--grey)" size="24"
                        @input="(input)=>updateRandomOrderSwitch(input)"/>

          </div>
        </div>
      </div>
    </div>

    <div class="userData">
      <router-link class="itemData border-bottom" to="/clerk/info">
        <div class="text">我的资料</div>
        <van-icon name="arrow" />
      </router-link>
      <router-link class="itemData border-bottom" to="/clerk/ranking-list">
        <div class="text">我的排名</div>
        <van-icon name="arrow" />
      </router-link>
      <router-link class="itemData" to="/clerk/grade">
        <div class="text">我的等级</div>
        <van-icon name="arrow" />
      </router-link>
    </div>

    <div v-if="itemSwitchList.length > 0" class="item-switch">
      <div class="title">服务开关</div>
      <van-row type="flex">
        <van-col v-for="(switchItem, index) of itemSwitchList" :key="index" class="switch-wrap" span="6"
                 style="padding: 2px 0">
          <van-switch :value="clerkItemSwitchIds.indexOf(switchItem.id) != -1" active-color="var(--primary-color)"
                      inactive-color="var(--grey)" size="18" @change="updateItemSwitch(switchItem.id)"/>
          <div class="item-name">{{ switchItem.name }}</div>
        </van-col>
      </van-row>
    </div>

    <div class="return" @click.stop.prevent="back">
      <van-icon name="arrow-left" size="16px"/>
      <div>返回</div>
    </div>

    <foot style="padding-bottom: 65px; margin-top: 40px;"
        v-if="$store.state.shop.id != 11 && $store.state.shop.id != 13 && $store.state.shop.id != 34 && $store.state.shop.id !=75
        && $store.state.shop.id !=127 && $store.state.shop.id != 1508"></foot>
    <div style="padding-bottom: 65px; margin-top: 40px;"  v-if="$store.state.shop.id == 34 || $store.state.shop.id == 127">
      <div class="text-center padding-tb-lg">
        <div  style="color: #ccc" @click="qrcodeShow=true">我要开店</div>
      </div>
    </div>

    <van-dialog v-model="qrcodeShow">
      <div class="flex justify-center">
        <img v-if="$store.state.shop.id == 34" src="/static/images/34/qrcode.png" style="width: 300px;" alt="qrcode">
        <img v-if="$store.state.shop.id == 127" src="/static/images/127/qrcode.png" style="width: 300px;" alt="qrcode">
      </div>
    </van-dialog>

    <tabbar></tabbar>
  </div>
</template>

<script>
import tabbar from "@/views/clerk/tabbar";
import {
  getClerk,
  getItemSwitchList,
  updateClerkAutoOnlineStatus,
  updateClerkStatus,
  updateItemSwitch, updateRandomOrderSwitch,
} from '@/api/clerk/clerk'
import {getRankingList} from "@/api/clerk/ranking";
import {Cell, CellGroup, Col, Dialog, Icon, Row, Switch, Toast} from 'vant';
import Vue from 'vue';
import PostAdd from "./post/post-add";
import foot from '@/views/foot';
import {getClerkSetting} from "@/api/shop";
import QuestionMark from "@/views/question-mark";


Vue.use(Row)
    .use(Col)
    .use(Icon)
    .use(CellGroup)
    .use(Cell)
    .use(Switch)
    .use(Dialog)
    .use(Toast)


export default {
  name: "clerkUser",
  components:{
    QuestionMark,
    PostAdd,
    tabbar,
    foot
  },

  data(){
    return{
      clerk:null,
      itemSwitchList: [],
      clerkItemSwitchIds: [],
      myRank:null,
      pageNo: 1,
      pageSize: 20,
      myRanking: {
        ranking:null
      },
      qrcodeShow: false,
      clerkIsAutoOnline: false,
      updateClerkStatusLoading: false,
      allowRandomOrderSwitch: null
    }
  },

  methods:{
    loadClerkInfo() {
      Promise.all([getClerk(), getItemSwitchList(),getClerkSetting()]).then((results) => {

        const data1 = results[0].data
        const data2 = results[1].data
        const data3 = results[2].data

        if (data1.code != 0) {
          Dialog.alert({
            title: '加载' + this.$store.state.label.clerkLabel + '信息失败',
            desc: data1.msg
          })
        }
        if (data2.code != 0) {
          Dialog.alert({
            title: '加载服务失败',
            message: data2.msg
          })
        }
        if(data3.code != 0){
          Dialog.alert({
            title: '加载店铺设置失败',
            message: data3.msg
          })
        }
        this.clerk = data1.clerk
        this.clerkIsAutoOnline = this.clerk.isAutoOnline
        this.itemSwitchList = data2.itemSwitchList
        this.clerkItemSwitchIds = data2.clerkItemSwitchIds
        this.allowRandomOrderSwitch = data3.setting.allowRandomOrderSwitch
      }).catch((e) => {
        Dialog.alert({
          title: '加载数据失败',
          message: JSON.stringify(e)
        })
      })
    },

    updateClerkIsAutoOnline() {
      updateClerkAutoOnlineStatus(this.clerkIsAutoOnline).then(res => {
        const data = res.data;
        if (data.code == 0) {
          Toast("修改成功")
        } else {
          this.clerkIsAutoOnline = false
          Dialog.alert({
            title: '修改失败',
            message: data.msg
          })
        }
      })
    },
    updateRandomOrderSwitch(randomOrderSwitch) {
      updateRandomOrderSwitch(randomOrderSwitch).then(res => {
        const data = res.data;
        if (data.code == 0) {
          Toast('修改成功')
          this.loadClerkInfo()
        } else {
          Dialog.alert({
            title: '修改失败',
            message: data.msg
          }).then(() => {
            this.loadData()
          })
        }
      })
    },
    updateItemSwitch(switchId) {
      let switchIds = [].concat(this.clerkItemSwitchIds)
      if (switchIds.indexOf(switchId) != -1) {
        switchIds.splice(switchIds.indexOf(switchId), 1)
      } else {
        switchIds.push(switchId)
      }

      Toast.loading({
        mask: true,
        message: '请稍候'
      })
      updateItemSwitch(
          JSON.stringify(switchIds),
          switchId
      ).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          this.clerkItemSwitchIds = switchIds
          Toast('修改成功')
        } else {
          this.loadData()
          Dialog.alert({
            title: '修改失败',
            message: data.msg
          })
        }
      })
    },

    updateStatus(status, role) {
      let updateAutoOnline = false;
      switch (role) {
        case 'clerk':
          this.updateClerkStatusLoading = true
          if (this.$hasFeature('auto_online')) {
            updateAutoOnline = true;
          }
          updateClerkStatus(status, updateAutoOnline).then(res => {
            this.updateClerkStatusLoading = false
            const data = res.data;
            if (data.code == 0) {
              Toast('修改状态成功')
              this.loadClerkInfo()
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改状态失败',
                message: data.msg
              })
            }
            this.loadData()
          });
          break;
        case 'kf':
          this.updateKfStatusLoading = true;
          updateKfStatus(status).then(res => {
            this.updateKfStatusLoading = false
            const data = res.data;
            if (data.code == 0) {
              this.kf.status = status
              Toast('修改状态成功')
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改状态失败',
                message: data.msg
              })
            }
          });
          break;
        case 'leader':
          this.updateLeaderStatusLoading = true;
          updateLeaderStatus(status).then(res => {
            this.updateLeaderStatusLoading = false
            const data = res.data;
            if (data.code == 0) {
              this.leader.status = status
              Toast('修改状态成功')
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改状态失败',
                message: data.msg
              })
            }
          });
          break;
      }

    },

    getRanking(){
      getRankingList(
          this.pageNo,
          this.pageSize
      ).then(res => {
        const data = res.data;
        if (data.code === 0) {
          if(data.myRanking){
            this.myRanking = data.myRanking
          }
        } else {
          Dialog.alert({
            title: '加载排名失败',
            message: data.msg
          })
        }
      })
    },

    back(){
      this.$router.push('/')
    },

    loadData() {
      // // 获取用户角色
      // Toast.loading({
      //   mask: true,
      //   message: '加载中...'
      // })
      // getUserRoles().then(res => {
      //   Toast.clear()
      //   const data = res.data;
      //   if (data.code == 0) {
      //     this.roles = data.roles;
      //     if (this.hasRole('clerk')) {
      //       this.loadClerkInfo()
      //     }
      //     if (this.hasRole('kf')) {
      //       this.loadKfInfo()
      //     }
      //     if (this.hasRole('leader')) {
      //       this.loadLeaderInfo()
      //     }
      //   } else {
      //     Dialog.alert({
      //       title: '获取用户角色失败',
      //       message: data.msg
      //     })
      //   }
      // })
    },
  },


  mounted() {
    this.loadClerkInfo()
    this.getRanking()
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  }
}
</script>

<style lang="less" scoped>

.header{
  padding: 20px 20px 20px;
  background: #fff;
  position: relative;

  //&::after{
  //  content: "";
  //  position: absolute;
  //  bottom: 0;
  //  left: 0;
  //  right: 0;
  //  border-bottom: 1px solid #ebedf0;
  //  transform: scaleY(.7);
  //}

  .photo{
    height: 80px;
    width: 80px;
  }

  .info{
    margin-left: 10px;
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
}

.userData{
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  margin: 7px 0;
  position: relative;
  background: #fff;

  .itemData{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    position: relative;
    color: #333;


  }

  .border-bottom{
    &::after{
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      border-bottom: 1px solid #ebedf0;
      transform: scaleY(1);
    }
  }
}

.item-switch {
  padding: 5px 10px 20px;
  //margin: 0 15px;
  background: #fff;

  .title{
    color: #333;
    padding: 15px 10px 15px;
  }

  .switch-wrap {
    text-align: center;
  }

  .item-name {
    font-size: 10px;
  }
}

.text{
  margin: 0 0 0;
}

.return{
  position: fixed;
  bottom: 68px;
  left: 21px;
  display: flex;
  align-items: center;
  border-radius: 50%;
  background: var(--primary-color);
  width: 50px;
  height: 50px;
  color: #fff;
}

</style>
